import formatCurrency from '../../../lib/rebuttal/formatCurrency'

function maskMoney(input: HTMLInputElement) {
  input.value = formatCurrency(parseInt(input.value))
  input.addEventListener('focus', (_moneyInput) => {
    input.setSelectionRange(1, input.value.length)
  })
}

export default function initMoneyMask(node: HTMLElement) {
  Array.from(node.querySelectorAll('[money]')).forEach((moneyInput) => {
    maskMoney(moneyInput as HTMLInputElement)
  })
}
